import { render, staticRenderFns } from "./RemoveFromCartButtonTab.vue?vue&type=template&id=cfe18232"
import script from "./RemoveFromCartButtonTab.vue?vue&type=script&lang=js"
export * from "./RemoveFromCartButtonTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports